export default "__VITE_ASSET__BXoKjSBZ__"